import React, { useState } from 'react';
import api from '../../services/api';

interface CreateRoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRoomCreated: (roomId: string) => void;
}

const CreateRoomModal: React.FC<CreateRoomModalProps> = ({
  isOpen,
  onClose,
  onRoomCreated,
}) => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleCreateRoom = async () => {
    setIsCreating(true);
    setError(null);

    try {
      const response = await api.post('/rooms');
      const { roomId } = response.data;
      onRoomCreated(roomId);
      onClose();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to create room');
    } finally {
      setIsCreating(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Create New Room</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <p style={{ color: 'var(--text-secondary)', marginBottom: 'var(--space-4)' }}>
            Create a new game room for up to 12 players. You'll be automatically joined as the host.
          </p>
          {error && (
            <div className="alert alert-error">
              {error}
              <button className="alert-close" onClick={() => setError(null)}>×</button>
            </div>
          )}
        </div>
        
        <div className="modal-footer">
          <button 
            className="btn btn-secondary" 
            onClick={onClose} 
            disabled={isCreating}
          >
            Cancel
          </button>
          <button 
            className="btn btn-primary"
            onClick={handleCreateRoom} 
            disabled={isCreating}
          >
            {isCreating ? (
              <>
                <div className="loading-spinner"></div>
                Creating...
              </>
            ) : (
              <>
                ✨ Create Room
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateRoomModal;